import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

function ThemeToggle({ compact }) {
  const { theme, toggleTheme } = useTheme();
  var isDark = theme === 'dark';

  if (compact) {
    return (
      <button
        onClick={toggleTheme}
        className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-1.5 tw-text-[#666] dark:tw-text-gray-300 hover:tw-text-[#1a1a1a] dark:hover:tw-text-white tw-transition-colors"
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        <i className={'fa ' + (isDark ? 'fa-sun-o' : 'fa-moon-o')} style={{ fontSize: '15px' }} />
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className="tw-flex tw-items-center tw-gap-2.5 tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#252525] tw-bg-transparent tw-border-0 tw-cursor-pointer tw-transition-colors"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <i className={'fa tw-w-4 tw-text-center tw-text-[#999] ' + (isDark ? 'fa-sun-o' : 'fa-moon-o')} />
      {isDark ? 'Light Mode' : 'Dark Mode'}
    </button>
  );
}

export default ThemeToggle;
